import React from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Header } from '@hofsync/design-system';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

/**
 * PublicLayout wraps public routes with the design-system Header and Footer.
 * Used for landing page, login, legal pages, etc.
 */
const PublicLayout: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, userPhone, logout } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      showToast(t('toast.logoutSuccess'), 'success');
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
      showToast(t('common.error'), 'error');
    }
  };

  const handleSettingsClick = () => {
    navigate('/settings');
  };

  // Build user info if authenticated
  const userInfo = isAuthenticated && userPhone ? { name: userPhone } : undefined;

  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header
        logoSrc="/hofsync_logo.gif"
        logoHref="/home"
        brandName="Hofsync"
        user={userInfo}
        onLogout={isAuthenticated ? handleLogout : undefined}
        onSettingsClick={isAuthenticated ? handleSettingsClick : undefined}
        loginHref={!isAuthenticated ? '/login' : undefined}
        loginLabel={t('common.login')}
        settingsLabel={t('header.settings')}
        signOutLabel={t('header.signOut')}
      />
      <main className="App-main" style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
